import { APP_ID } from '../../../shared/config/constants';
import { monthDiff } from '../../../shared/helpers/date';
import gtm from '../../../shared/helpers/gtm';

const trackNavigationClick = (action: string, newDate: Date) => {
  // As usual we use the `trackUserEvent` function to track an event and provide it
  // with a label so we can see what was acutally clicked on. In this function below
  // I also calculate how many months you've gone in to the future. That way we can
  // track that as well and see how far people click into the FUTURE.
  const today = new Date();
  const monthDifference = monthDiff(today, newDate);
  const formattedMonthDifference = `${monthDifference} month${monthDifference === 1 || monthDifference === -1 ? '' : 's'} ${monthDifference >= 0 ? 'in advance' : 'in the past'}`;
  gtm.trackUserEvent(String(APP_ID), 'Month navigation click', action, formattedMonthDifference);
};

export default trackNavigationClick;
